import React from 'react';
import { connect } from 'react-redux';
import Loadable from 'components/shared/loadable';
import Table from 'components/shared/table';
import * as actions from 'actions/inPersonTraining/eventOverview/attendees';
import AttendanceRowSingleColumn from './AttendanceRowSingleColumn';

const AttendanceTableSingleColumn = ({
  attendances,
  filters,
  loading,
  onPageChange,
  onPerPageChange,
  updateAttendees,
  sessions,
  isMultiSession,
}) => (
  <Table alternate>
    <Loadable loading={loading}>
      {attendances.data.map(attendance => (
        <AttendanceRowSingleColumn
          updateAttendance={updateAttendees}
          key={attendance.user.id}
          attendance={attendance}
          sessions={sessions}
          isMultiSession={isMultiSession}
        />
      ))}
    </Loadable>
    <Table.Pagination
      className="p-16 bt-gray-lighter"
      onPageChange={onPageChange}
      onPerPageChange={onPerPageChange}
      page={filters.page}
      pageCount={attendances.totalPages}
      perPage={filters.perPage}
    />
  </Table>
);

const mapStateToProps = ({ attendees }) => ({
  attendances: attendees.attendances,
  filters: attendees.filters,
  loading: attendees.loading,
});

const mapDispatchToProps = {
  onPageChange: page => actions.updateFilters({ page }),
  onPerPageChange: perPage => actions.updateFilters({ perPage }),
  updateAttendees: () => actions.updateAttendees(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AttendanceTableSingleColumn);
